import { Controller } from "@hotwired/stimulus";

// The Age Analysis preview's bucket picker. Every preset is already in the DOM
// as its own layer; this only decides which one is showing, via data-preset,
// so Tailwind's group-data-[preset=N]/ages variants do the crossfade.
//
// Advancing is driven by the section's auto-play (preview-mode:flip) rather
// than a second timer, so the whole demo stays on one clock.
export default class extends Controller {
  static values = { count: { type: Number, default: 4 } };

  select(event) {
    this.show(event.params.preset);
  }

  advance() {
    this.show((this.current + 1) % this.countValue);
  }

  get current() {
    return Number(this.element.dataset.preset || 0);
  }

  show(index) {
    this.element.dataset.preset = index;
  }
}
